var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card clickable",staticStyle:{"color":"#ffffff","font-weight":"bold"},style:(_vm.styleMe),attrs:{"body-style":_vm.cardBodyStyle}},[_c('div',{staticClass:"d-flex justify-content-center dash-content"},[_c('span',{staticClass:"align-self-center title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db3ad76","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/Dashboard/DashItemMenu.vue
// module id = 733
// module chunks = 1